function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length);
    }
  }

  return null;
}

function loadScript(src, callback) {
  const script = document.createElement('script');
  script.src = src;
  script.onload = callback;
  document.head.appendChild(script);
}

if (typeof Spinner === 'undefined') {
  loadScript('//cdnjs.cloudflare.com/ajax/libs/spin.js/2.3.2/spin.min.js', function () {
    setTimeout(function () {
      const spinner = document.getElementById('rv__spinner');
      if (spinner) {
        new Spinner({
          top: '50%',
          scale: 0.5
        }).spin(spinner);
      }
    }, 450);
  });
}

function removeHandleFromCookie(cookieName, handleToRemove) {
  try {
    let products = JSON.parse(getCookie(cookieName) || '[]');
    products = products.filter(item => item.handle !== handleToRemove);
    setCookie(cookieName, JSON.stringify(products), 365);
  } catch (e) {
    console.warn('Failed removing invalid product from cookie:', handleToRemove);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('recently-viewed-products');
  const cookieName = 'rv__recent_products';
  const currentHandle = window.pHandle;
  const maxProducts = 10;

  let recentProducts = [];

  try {
    const cookieData = getCookie(cookieName);
    recentProducts = cookieData ? JSON.parse(cookieData) : [];
  } catch (e) {
    recentProducts = [];
  }

  const collectionHandle = window.GA_CONTEXT?.collection_handle || '';

  // Remove duplicate current product
  recentProducts = recentProducts.filter(item => item.handle !== currentHandle);

  // Maintain max products
  if (recentProducts.length >= maxProducts) {
    recentProducts.shift();
  }

  // Save current product
  if (currentHandle) {
    recentProducts.push({
      handle: currentHandle,
      collection: collectionHandle
    });
  }

  setCookie(cookieName, JSON.stringify(recentProducts), 365);

  // No recently viewed section on current page
  if (!container) return;

  // Exclude current product from display
  const filteredProducts = recentProducts.filter(
    item => item.handle !== currentHandle
  );

  if (!filteredProducts.length) {
    container.innerHTML = `
      <div class="recent-wrapper-noProduct">
        No Gems Viewed Yet.<br>
        <span>But our gemstones are waiting for you.</span>
      </div>
    `;
    return;
  }

  container.innerHTML = '<ul class="recent-wrapper grid product-grid"></ul>';

  const wrapper = container.querySelector('.recent-wrapper');

  Promise.all(
    filteredProducts
      .slice()
      .reverse()
      .slice(0, maxProducts)
      .map(item => {
        return fetch(`/products/${item.handle}?section_id=recently-render-products`)
          .then(response => {
            if (response.status === 404) {
              removeHandleFromCookie(cookieName, item.handle);
              return null;
            }

            if (!response.ok) {
              throw new Error(`Failed to load ${item.handle}`);
            }

            return response.text();
          })
          .then(html => {
            if (!html) return null;

            const temp = document.createElement("div");
            temp.innerHTML = html;

            // Extract only the product card
            const li = temp.querySelector("li.grid__item");

            if (!li) {
              removeHandleFromCookie(cookieName, item.handle);
              return null;
            }

            return li;
          })
          .catch(err => {
            console.warn(err);
            return null;
          });
      })
  ).then(cards => {
    cards.forEach(li => {
      if (li) {
        wrapper.appendChild(li);
      }
    });

    document.getElementById("rv__spinner")?.remove();
  });
});